import { useCallback } from 'react'
import { useFeatureFlags } from 'features/FeatureFlags'

import { DebitCardTransactionStatusV2 } from 'types/gql-global-types'
import { useAccountFilters } from 'layouts/AccountLayout/hooks/useAccountFilters/useAccountFilters'
import { ReceiptIncluded } from 'layouts/AccountLayout/hooks/useAccountFiltersValues/useAccountFiltersValues'

import { useGetOutstandingExpensesFilter } from '../useGetOutstandingExpensesFilter/useGetOutstandingExpensesFilter'

export const useToggleOutstandingExpensesFilter = () => {
  const { setReceipt, resetReceipt, resetStatus, setStatus } =
    useAccountFilters()
  const { isOutstandingExpensesFilterOn } = useGetOutstandingExpensesFilter()
  const flags = useFeatureFlags()

  const toggleFilter = useCallback(() => {
    if (!flags.CorpCardsOutstandingTransactionsFilter) {
      return
    }
    if (isOutstandingExpensesFilterOn) {
      resetReceipt()
      resetStatus()
    } else {
      setReceipt([ReceiptIncluded.NOT_INCLUDED])
      setStatus([DebitCardTransactionStatusV2.APPROVED])
    }
  }, [
    resetStatus,
    setStatus,
    resetReceipt,
    setReceipt,
    isOutstandingExpensesFilterOn,
    flags.CorpCardsOutstandingTransactionsFilter,
  ])

  const resetFilter = useCallback(() => {
    if (!flags.CorpCardsOutstandingTransactionsFilter) {
      return
    }
    resetReceipt()
    resetStatus()
  }, [flags.CorpCardsOutstandingTransactionsFilter, resetReceipt, resetStatus])

  return {
    toggleFilter,
    resetFilter,
  }
}
